import * as React from "react";
import { Button, useRefresh } from "react-admin";
import { Box, Checkbox, Grid } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import CustomSelect from "../../unit/forms/CustomSelect";
import useNotify from "../../unit/useNotify";
import CustomDialogTitle from "../../unit/CustomDialogTitle";
import PaperComponent from "../../unit/PaperComponent";

export default function CustomLoanPortfolioDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record: recordProp } = props;
  const lastDate = recordProp?.lastDate;
  const accruedInterestAmount = recordProp?.accruedInterestAmount;
  const [open, setOpen] = React.useState(false);
  const [primarySubPortfolioOptionList, setPrimarySubPortfolioOptionList] =
    React.useState<{ label: string; value: any }[]>([]);
  const [secondarySubPortfolioOptionList, setSecondarySubPortfolioOptionList] =
    React.useState<{ label: string; value: any }[]>([]);
  const [primaryPortfolioValue, setPrimaryPortfolioValue] = React.useState("");
  const [primarySubPortfolioValue, setPrimarySubPortfolioValue] =
    React.useState("");
  const [secondaryPortfolioValue, setSecondaryPortfolioValue] =
    React.useState("");
  const [secondarySubPortfolioValue, setSecondarySubPortfolioValue] =
    React.useState("");
  const [excludeFormMetroReport, setExcludeFormMetroReport] =
    React.useState(false);
  const [isSubmit, setIsSubmit] = React.useState(false);
  const refresh = useRefresh();
  React.useEffect(() => {
    if (
      primaryPortfolioValue != ""
      // primarySubPortfolioValue != "" &&
      // secondaryPortfolioValue != "" &&
      // secondarySubPortfolioValue != ""
    ) {
      setIsSubmit(true);
    }
  }, [
    primaryPortfolioValue,
    primarySubPortfolioValue,
    secondaryPortfolioValue,
    secondarySubPortfolioValue,
  ]);
  const handleClickOpen = () => {
    setOpen(true);
    //get the data from the server and set the values
    const reqUrl = `loans/actions/portfolioInfo`;
    sendRequest(reqUrl, { id: appId }).then((response) => {
      console.log("response.data===>", response.data);
      const data = response.data;
      console.log("data.primaryPortfolio===>", data.PrimaryPortfolio);
      if (data && response.code == "200") {
        setPrimaryPortfolioValue(data.PrimaryPortfolio);
        let primarySubPortfolioOptionList: { label: string; value: any }[] = [];
        for (let key in primaryportfolio[data.PrimaryPortfolio]) {
          primarySubPortfolioOptionList.push({
            value: primaryportfolio[data.PrimaryPortfolio][key],
            label: primaryportfolio[data.PrimaryPortfolio][key],
          });
        }
        setPrimarySubPortfolioOptionList(primarySubPortfolioOptionList);

        setPrimarySubPortfolioValue(data.PrimarySubPortfolio);
        setSecondaryPortfolioValue(data.SecondaryPortfolio);
        let secondarySubPortfolioOptionList: { label: string; value: any }[] =
          [];
        for (let key in secondaryportfolio[data.SecondaryPortfolio]) {
          secondarySubPortfolioOptionList.push({
            value: secondaryportfolio[data.SecondaryPortfolio][key],
            label: secondaryportfolio[data.SecondaryPortfolio][key],
          });
        }
        setSecondarySubPortfolioOptionList(secondarySubPortfolioOptionList);
        setSecondarySubPortfolioValue(data.SecondarySubPortfolio);
        setExcludeFormMetroReport(
          data.exclude_from_metro_report == "yes" ? true : false
        );
      }
    });
  };

  const handleClose = () => {
    setOpen(false);
    setIsSubmit(false);
    // refresh();
  };
  let primaryportfolio = new Array();
  let secondaryportfolio = new Array();
  const localBank = localStorage.getItem("bank") || "";
  const authrole = localStorage.getItem("authrole") || "";
  if (localBank == "nolb" || authrole == "admin") {
    primaryportfolio["DAF1"] = new Array();
    primaryportfolio["DAF2"] = new Array();
    primaryportfolio["DAF3"] = new Array();
  }
  if (localBank == "ircceo" || authrole == "admin") {
    primaryportfolio["RV027-ORR"] = new Array();
    primaryportfolio["RV027-ORR"].push("GH200");
    primaryportfolio["RV027-ORR"].push("2023 Fresh Start Fund");
    primaryportfolio["RV100 Unrestricted"] = new Array();
    primaryportfolio["RV100 Unrestricted"].push("U2000");
    primaryportfolio["RV100 Unrestricted"].push("2023 Fresh Start Fund");
    primaryportfolio["Resilience Loans"] = new Array();
    primaryportfolio["Resilience Loans"].push("Resilience Loans");
    primaryportfolio["Resilience Loans"].push("2023 Fresh Start Fund");
    primaryportfolio["RG200 CDFI General"] = new Array();
    primaryportfolio["RG200 CDFI General"].push("GG100");
    primaryportfolio["RG200 CDFI General"].push("RG200-CDFI General");
    primaryportfolio["RG200 CDFI General"].push("2023 Fresh Start Fund");
    primaryportfolio["RIN SIF"] = new Array();
    primaryportfolio["RIN SIF"].push("RIN SIF");
    primaryportfolio["RIN SIF"].push("2023 Fresh Start Fund");
    primaryportfolio["RV201 CDFI 2019"] = new Array();
    primaryportfolio["RV201 CDFI 2019"].push("RV201 CDFI 2019");
    primaryportfolio["RV201 CDFI 2019"].push("2023 Fresh Start Fund");
    primaryportfolio["RV202 CDFI 2021"] = new Array();
    primaryportfolio["RV202 CDFI 2021"].push("RV202 CDFI 2021");
    primaryportfolio["RV202 CDFI 2021"].push("2023 Fresh Start Fund");
    primaryportfolio["RV203 CDFI COVID"] = new Array();
    primaryportfolio["RV203 CDFI COVID"].push("RV203 CDFI COVID");
    primaryportfolio["RV203 CDFI COVID"].push("2023 Fresh Start Fund");
    primaryportfolio["SBA"] = new Array();
    primaryportfolio["SBA"].push("SBA");
    primaryportfolio["SBA"].push("2023 Fresh Start Fund");
    primaryportfolio["SAFE"] = new Array();
    primaryportfolio["SAFE"].push("SAFE");
    primaryportfolio["SAFE"].push("RV203 - CDFI COVID T1");
    primaryportfolio["SAFE"].push("2023 Fresh Start Fund");
    primaryportfolio["Fresh Start Fund"] = new Array();
    primaryportfolio["Fresh Start Fund"].push("2023 Fresh Start Fund");
    primaryportfolio["FSF 2023"] = new Array();
    primaryportfolio["FSF 2023"].push("2023 Fresh Start Fund");
    primaryportfolio["FSF 2023"].push("Other");
    primaryportfolio["General"] = new Array();
    primaryportfolio["General"].push("RIN SIF");
    primaryportfolio["General"].push("CDFI");
    primaryportfolio["General"].push("Other");
    primaryportfolio["Other"] = new Array();
    primaryportfolio["Other"].push("2023 Fresh Start Fund");
    primaryportfolio["Other"].push("Other");

    secondaryportfolio["Auto Loans"] = new Array();
    secondaryportfolio["Auto Loans"].push("Auto");
    secondaryportfolio["Business Loans"] = new Array();
    secondaryportfolio["Business Loans"].push("Business ORR");
    secondaryportfolio["Business Loans"].push("Business RF-General");
    secondaryportfolio["Business Loans"].push("Business RF-ORR");
    secondaryportfolio["Business Loans"].push("Business-General");
    secondaryportfolio["Business Loans"].push("Child Care-General");
    secondaryportfolio["Business Loans"].push("Child Care-ORR");
    secondaryportfolio["Business Loans"].push("Whole Planet 2023");
    secondaryportfolio["Business Loans"].push("SBA");
    secondaryportfolio["Credit Building Loans"] = new Array();
    secondaryportfolio["Credit Building Loans"].push("PSP-Credit Building");
    secondaryportfolio["Credit Building Loans"].push(
      "Credit Building -General"
    );
    secondaryportfolio["Credit Building Loans"].push("Credit Building ORR");
    secondaryportfolio["Education Loans"] = new Array();
    secondaryportfolio["Education Loans"].push("Education loan");
    secondaryportfolio["Immigration"] = new Array();
    secondaryportfolio["Immigration"].push("Immigration");
    secondaryportfolio["Personal Loans"] = new Array();
    secondaryportfolio["Personal Loans"].push("Personal Loan");
    secondaryportfolio["Recoverable Grant"] = new Array();
    secondaryportfolio["Recoverable Grant"].push("Recoverable Grant");
    secondaryportfolio["Resilience Loans"] = new Array();
    secondaryportfolio["Resilience Loans"].push("PSP-Resilience Loans");
    secondaryportfolio["Resilience Loans"].push("Resilience Loans");
    secondaryportfolio["Other"] = new Array();
    secondaryportfolio["Other"].push("Other");
  }

  //setPrimaryPortfolioOptionList

  let primaryPortfolioOptionList: { label: string; value: any }[] = [];
  primaryPortfolioOptionList.push({ label: "Select", value: "" });
  for (let key in primaryportfolio) {
    primaryPortfolioOptionList.push({ value: key, label: key });
  }

  let secondaryPortfolioOptionList: { label: string; value: any }[] = [];
  secondaryPortfolioOptionList.push({ label: "Select", value: "" });
  for (let key in secondaryportfolio) {
    secondaryPortfolioOptionList.push({ value: key, label: key });
  }

  // console.log("primaryPortfolioOptionList===>", primaryPortfolioOptionList);

  const handleChangePrimaryPortfolio = (e) => {
    setPrimaryPortfolioValue(e.target.value);
    // console.log("e.target.value===>", e.target.value);
    let primarySubPortfolioOptionList: { label: string; value: any }[] = [];
    primarySubPortfolioOptionList.push({ label: "Select", value: "" });
    for (let key in primaryportfolio[e.target.value]) {
      primarySubPortfolioOptionList.push({
        value: primaryportfolio[e.target.value][key],
        label: primaryportfolio[e.target.value][key],
      });
    }
    setPrimarySubPortfolioOptionList(primarySubPortfolioOptionList);
  };

  const handleChangeSecondaryPortfolio = (e) => {
    setSecondaryPortfolioValue(e.target.value);
    console.log("e.target.value===>", e.target.value);
    let secondarySubPortfolioOptionList: { label: string; value: any }[] = [];
    secondarySubPortfolioOptionList.push({ label: "Select", value: "" });
    for (let key in secondaryportfolio[e.target.value]) {
      secondarySubPortfolioOptionList.push({
        value: secondaryportfolio[e.target.value][key],
        label: secondaryportfolio[e.target.value][key],
      });
    }
    setSecondarySubPortfolioOptionList(secondarySubPortfolioOptionList);
  };
  return (
    <React.Fragment>
      <Button
        id="button-loan-portfolio-edit"
        label="Portfolio edit"
        variant="contained"
        size="medium"
        sx={{
          marginLeft: "10px",
          width: "175px",
          background: "#00CCB1",
          "&:hover": { background: "#00CCB1" },
        }}
        onClick={handleClickOpen}
      />
      <Dialog
        id="dialog-loan-portfolio-edit"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="md"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries((formData as any).entries());
            console.log("PortfolioDialog formJson =====>", formJson);
            // return false;
            const reqUrl = `loans/actions/portfolio`;
            const responseBack = await sendRequest(reqUrl, {
              id: appId,
              data: formJson,
            });
            console.log(responseBack.data);
            if (responseBack && responseBack.code == "200") {
              successNotify("Data saved successfully");
              handleClose();
              refresh();
            } else {
              errorNotify(responseBack?.message || "Data not saved!");
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e5e5e5",
            mb: 2,
          }}
        >
          <CustomDialogTitle title={`Active Loan`} subTitle="Portfolio edit" />
        </DialogTitle>
        <DialogContent>
          <Box>
            <DialogContentText></DialogContentText>
            <Grid container sx={{ mb: 1, pb: 1 }}>
              <Grid sx={{ mb: 2 }} container>
                <Grid item xs={5} sx={{ pt: 1 }}>
                  <HeaderLabelTitle fullWidth title="Primary Portfolio" />
                </Grid>
                <Grid item xs={5}>
                  <CustomSelect
                    fullWidth
                    variant="outlined"
                    name="PrimaryPortfolio"
                    optionlist={primaryPortfolioOptionList}
                    onChange={(e) => {
                      handleChangePrimaryPortfolio(e);
                    }}
                    value={primaryPortfolioValue}
                  />
                </Grid>
                <Grid item xs={2}></Grid>
              </Grid>
              {(localBank == "ircceo" || authrole == "admin") && (
                <Grid sx={{ mb: 2 }} container>
                  <Grid item xs={5} sx={{ pt: 1 }}>
                    <HeaderLabelTitle fullWidth title="Primary SubPortfolio" />
                  </Grid>
                  <Grid item xs={5}>
                    <CustomSelect
                      fullWidth
                      variant="outlined"
                      name="PrimarySubPortfolio"
                      optionlist={primarySubPortfolioOptionList}
                      value={primarySubPortfolioValue}
                      onChange={(e) => {
                        setPrimarySubPortfolioValue(e.target.value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={2}></Grid>
                </Grid>
              )}
              {(localBank == "ircceo" || authrole == "admin") && (
                <Grid sx={{ mb: 2 }} container>
                  <Grid item xs={5} sx={{ pt: 1 }}>
                    <HeaderLabelTitle fullWidth title="Secondary Portfolio" />
                  </Grid>
                  <Grid item xs={5}>
                    <CustomSelect
                      fullWidth
                      variant="outlined"
                      name="SecondaryPortfolio"
                      optionlist={secondaryPortfolioOptionList}
                      value={secondaryPortfolioValue}
                      onChange={(e) => {
                        handleChangeSecondaryPortfolio(e);
                      }}
                    />
                  </Grid>
                  <Grid item xs={2}></Grid>
                </Grid>
              )}
              {(localBank == "ircceo" || authrole == "admin") && (
                <Grid sx={{ mb: 2 }} container>
                  <Grid item xs={5} sx={{ pt: 1 }}>
                    <HeaderLabelTitle
                      fullWidth
                      title="Secondary SubPortfolio"
                    />
                  </Grid>
                  <Grid item xs={5}>
                    <CustomSelect
                      fullWidth
                      variant="outlined"
                      name="SecondarySubPortfolio"
                      optionlist={secondarySubPortfolioOptionList}
                      value={secondarySubPortfolioValue}
                      onChange={(e) => {
                        setSecondarySubPortfolioValue(e.target.value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={2}></Grid>
                </Grid>
              )}
              {/* Exclude From Metro II, checkbox */}
              {(localBank == "ircceo" || authrole == "admin") && (
                <Grid sx={{ mb: 2 }} container>
                  <Grid item xs={5} sx={{ pt: 1 }}>
                    <HeaderLabelTitle fullWidth title="Exclude From Metro II" />
                  </Grid>
                  <Grid item xs={5}>
                    <Checkbox
                      id="exclude_from_metro_report"
                      name="exclude_from_metro_report"
                      checked={excludeFormMetroReport}
                      onChange={(e) => {
                        setExcludeFormMetroReport(e.target.checked);
                      }}
                    />
                  </Grid>
                  <Grid item xs={2}></Grid>
                </Grid>
              )}
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          {isSubmit && <CustomButtonSubmit label="Confirm" />}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
